export { Closed } from './closed.component';
